var map = {
	"./submenu_award_0.png": 326,
	"./submenu_award_0_active.png": 1645,
	"./submenu_award_1.png": 8415,
	"./submenu_award_1_active.png": 6410,
	"./submenu_index_0.png": 1673,
	"./submenu_index_0_active.png": 4084,
	"./submenu_index_1.png": 3552,
	"./submenu_index_1_active.png": 7015,
	"./submenu_index_2.png": 5531,
	"./submenu_index_2_active.png": 8206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9833;